// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4277) return "static/chunks/4277-c7b3833ab61505cc.js";
	if (chunkId === 6339) return "static/chunks/6339-e30d4a84c81ce709.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"745":"aee476fe828fec6a","1026":"d4a215ee118fd515","1487":"eb91d11cabd5119e","3057":"164768de0ead1fcd","7472":"bc1c9747581d6016","7539":"417046a10708f51c"}[chunkId] + ".js";
};